import { Button } from '@helvetia/components/Button'
import * as React from 'react'

interface Props {
  title: React.ReactElement<any>
  buttonText: string
  onClose: () => void
}

export const Modal: React.SFC<Props> = ({
  title,
  buttonText,
  children,
  onClose,
}) => {
  return (
    <div
      className="uxc-m-screen-overlay uxc-js-m-screen-overlay uxc-m-screen-overlay--height-centered uxc-state-m-screen-overlay--open"
      data-t-name="UXCScreenOverlay"
      data-overlay-id="overlay-m-legal-disclaimer"
      data-t-id="1"
    >
      <div className="uxc-m-screen-overlay__background" />
      <div className="uxc-h-fluid-wrapper">
        <div className="uxc-m-screen-overlay__container uxc-js-m-screen-overlay__container uxc-m-screen-overlay__container--width-m">
          <div className="uxc-m-screen-overlay__inner-container uxc-js-m-screen-overlay__inner-container">
            <div className="uxc-m-screen-overlay__bar uxc-js-m-screen-overlay__bar">
              <div className="uxc-h-fluid-wrapper uxc-h-fluid-wrapper--full@tablet uxc-h-fluid-wrapper--full@desktop uxc-h-fluid-wrapper--full@hd">
                <div className="uxc-h-spacer uxc-h-spacer--xs@mobile uxc-h-spacer--m@tablet uxc-h-spacer--m@desktop uxc-h-spacer--m@hd" />
                <div className="row">
                  <div className="col-xs-10 col-sm-7 col-md-7 col-lg-7 col-sm-offset-2 col-md-offset-2 col-lg-offset-2">
                    {title}
                  </div>
                  <div className="uxc-h-spacer uxc-h-spacer--xxxs" />
                </div>
              </div>
            </div>
            <div
              className="uxc-m-screen-overlay__body uxc-js-m-screen-overlay__body uxc-m-screen-overlay__body--scroll-shadow"
              style={{ height: 'calc(100% - 140px)' }}
            >
              <div className="uxc-m-screen-overlay__body-outer" id="scrollable">
                <div className="uxc-m-screen-overlay__body-inner">
                  <div className="uxc-h-fluid-wrapper uxc-h-fluid-wrapper--full@tablet uxc-h-fluid-wrapper--full@desktop uxc-h-fluid-wrapper--full@hd">
                    <div className="row">
                      <div className="col-xs-12 col-sm-8 col-md-8 col-lg-8 col-sm-offset-2 col-md-offset-2 col-lg-offset-2">
                        <div className="uxc-h-spacer uxc-h-spacer--xxs" />
                        {children}
                        <div className="uxc-h-spacer uxc-h-spacer--xxs" />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="uxc-h-spacer uxc-h-spacer--xxs" />
                <div className="uxc-m-screen-overlay__bar uxc-js-m-screen-overlay__bar">
                  <div
                    className="uxc-h-fluid-wrapper uxc-h-fluid-wrapper--full@tablet uxc-h-fluid-wrapper--full@desktop uxc-h-fluid-wrapper--full@hd"
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                    }}
                  >
                    <div className="row">
                      <Button primary onClick={onClose}>
                        {buttonText}
                      </Button>
                      <div className="uxc-h-spacer uxc-h-spacer--xs" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
